import { render, staticRenderFns } from "./MatterList.vue?vue&type=template&id=6fb10d1d"
import script from "./MatterList.vue?vue&type=script&lang=js"
export * from "./MatterList.vue?vue&type=script&lang=js"
import style0 from "./MatterList.vue?vue&type=style&index=0&id=6fb10d1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports